import * as React from "react";

export const Map = () => {
  return (
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2561.4316338341437!2d19.924897315709725!3d50.059477623339795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47165b0b5b5330a1%3A0x8a5f0671d71fdabc!2sJ%C3%B3zefa%20Pi%C5%82sudskiego%2028A%2C%2031-111%20Krak%C3%B3w!5e0!3m2!1sen!2spl!4v1589970303526!5m2!1sen!2spl" height="600" frameborder="0" style={{width: "100%"}} allowfullscreen="" aria-hidden="false" tabindex="0" title="map"></iframe>
  );
};

export default Map;
